import type { Locale } from 'date-fns';
import type { DateFormatConfig } from '@/i18n';
import { DEFAULT_DATE_FORMATS, LANGUAGES } from '@/i18n';

/**
 * Returns the date-fns locale for the given i18n language code.
 * Used for date formatting and Calendar (react-day-picker) localization.
 */
export function getDateFnsLocale(lang: string): Locale {
  const entry = LANGUAGES.find((l) => l.code === lang);
  return entry?.dateFnsLocale ?? LANGUAGES[0].dateFnsLocale;
}

/**
 * Returns date format strings for the given language (short date, datetime, month+day).
 * Used with date-fns format() so dates follow locale style (e.g. TR: "15 Şub 2026", "15 Şub 2026 16:54").
 */
export function getDateFormats(lang: string): DateFormatConfig {
  const entry = LANGUAGES.find((l) => l.code === lang);
  return { ...DEFAULT_DATE_FORMATS, ...entry?.dateFormats };
}
